export default __webpack_public_path__ + "static/media/evenShotMascot.e6ef80bc.png";